import React from 'react'
import { motion } from 'framer-motion';

const Card = ({item:{title,des,icon}}) => {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
      }}
      className="w-full p-5 h-auto min-h-[240px] rounded-xl border border-white/10 bg-white/5 backdrop-blur-md group hover:border-cyan-500/30 hover:bg-cyan-500/5 transition-all duration-500 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-blue-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

      <div className="relative z-10 flex flex-col h-full gap-4">
        <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-cyan-500/10 border border-cyan-500/20 group-hover:bg-cyan-500/20 group-hover:border-cyan-500/30 transition-all duration-300">
          {icon ? (
            <span className="text-xl text-cyan-400">{icon}</span>
          ) : (
            <div className="w-5 h-5 flex flex-col justify-between">
              <span className="w-full h-[2px] rounded bg-cyan-400"></span>
              <span className="w-full h-[2px] rounded bg-cyan-400"></span>
              <span className="w-full h-[2px] rounded bg-cyan-400"></span>
            </div>
          )}
        </div>

        <div className="flex flex-col gap-2">
          <h2 className="text-lg font-titleFont font-bold text-white group-hover:text-cyan-300 transition-colors duration-300">
            {title}
          </h2>
          <p className="text-xs text-gray-400 leading-relaxed">{des}</p>
        </div>
      </div>
    </motion.div>
  );
}

export default Card
